import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useCreateTeamDialog } from '@utils/dialogs-hooks';
import { roles } from '@shared/static/roles';
import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';
import { RenderItemTeam } from '@shared/ui/forms/select-render';

export default function InviteTeamPicker({
  control,
  errors,
  groupsWithoutTeamLead,
  role,
  group,
  onSelectOpen,
  loading,
}) {
  const { t } = useTranslation();
  const { openCreateTeamDialog } = useCreateTeamDialog();
  const { allGroups } = useSelector((state) => state.my_team);

  // Выбор данных для селекта: TEAM_LEAD - группы без тимлида, TEAM_MEMBER - все группы
  const baseData = role === roles.TEAM_LEAD ? groupsWithoutTeamLead : allGroups;

  // Добавляем group из пропсов в список, если его там нет (для корректного отображения)
  // TEAM_LEAD: только если teamLead === null
  const shouldAddGroup =
    group?.id &&
    !baseData.some((g) => g.id === group.id) &&
    (role === roles.TEAM_MEMBER || !group.teamLead);
  const selectData = shouldAddGroup ? [...baseData, group] : baseData;

  return (
    <BasicSelectInput
      control={control}
      name="group_id"
      label={t('team')}
      onButtonClick={() => openCreateTeamDialog(null)}
      error={errors.group_id}
      isRequired
      data={selectData}
      Render={RenderItemTeam}
      searchable
      onOpen={onSelectOpen}
      loading={loading}
    />
  );
}
